
import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
  }


const AboutIcon: React.FC<IconProps> = ({className, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            className={className}
            {...props} // This allows you to pass additional props like className, style, etc.
        >
            <path
                d="M19 7.23611C19 5.03004 16.901 3.24121 14.312 3.24121C12.377 3.24121 10.715 4.24082 10 5.66745C9.285 4.24082 7.623 3.24121 5.687 3.24121C3.1 3.24121 1 5.03004 1 7.23611C1 13.6457 10 17.8892 10 17.8892C10 17.8892 19 13.6457 19 7.23611Z"
                stroke="currentColor"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AboutIcon;
